module.exports = __webpack_public_path__ + "static/media/betaland.d4f468e3.svg";